var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomaticGrab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14676",
    "data-name": "Group 14676",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11355",
    "data-name": "Path 11355",
    d: "M83.44,38.2H77.823a32.435,32.435,0,0,0-3.814-9.178l3.981-3.981a1.558,1.558,0,0,0,0-2.206l-8.823-8.825a1.559,1.559,0,0,0-2.206,0l-3.981,3.981A32.381,32.381,0,0,0,53.8,14.178V8.56A1.56,1.56,0,0,0,52.24,7H39.76A1.561,1.561,0,0,0,38.2,8.56v5.618a32.372,32.372,0,0,0-9.178,3.814l-3.981-3.981a1.558,1.558,0,0,0-2.206,0l-8.823,8.825a1.558,1.558,0,0,0,0,2.206l3.981,3.981A32.409,32.409,0,0,0,14.179,38.2H8.56A1.561,1.561,0,0,0,7,39.76V52.24A1.56,1.56,0,0,0,8.56,53.8h5.618a32.418,32.418,0,0,0,3.814,9.179L14.011,66.96a1.558,1.558,0,0,0,0,2.206l8.823,8.823a1.558,1.558,0,0,0,2.206,0l3.981-3.981A32.417,32.417,0,0,0,38.2,77.823V83.44A1.56,1.56,0,0,0,39.759,85h12.48a1.559,1.559,0,0,0,1.56-1.56V77.823a32.464,32.464,0,0,0,9.179-3.814l3.981,3.981a1.558,1.558,0,0,0,2.206,0l8.823-8.823a1.558,1.558,0,0,0,0-2.206l-3.981-3.981A32.445,32.445,0,0,0,77.821,53.8H83.44A1.559,1.559,0,0,0,85,52.24V39.76A1.56,1.56,0,0,0,83.44,38.2ZM66.28,46A20.28,20.28,0,1,1,46,25.72,20.3,20.3,0,0,1,66.28,46Z",
    transform: "translate(-7 -7)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11356",
    "data-name": "Path 11356",
    d: "M25.642,38.214l4.326,4.326L45.48,27.028",
    transform: "translate(3.439 4.216)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticGrab);
export default __webpack_public_path__ + "static/media/automatic-grab.746dcf8af1129002d595f92f154a33ac.svg";
export { ForwardRef as ReactComponent };